// extracted by mini-css-extract-plugin
export var footer = "_nj-0";
export var inherit = "_nj-1";
export var input = "_nj-2";
export var modalContent = "_nj-3";
export var quillEditor = "_nj-4";
export var subtitle = "_nj-5";